export type ClubMarkerLayout = {
  width: number;
  cardHeight: number;
  totalHeight: number;
  iconAnchor: [number, number];
  popupAnchor: [number, number];
};

const MIN_WIDTH = 132;
const MAX_WIDTH = 194;
const ICON_COLUMN_WIDTH = 24;
const HORIZONTAL_PADDING = 19;
const APPROX_CHAR_WIDTH = 7.3;
const BASE_CARD_HEIGHT = 48;
const EXTRA_LINE_HEIGHT = 12;
const MAX_VISIBLE_LINES = 3;
const PIN_X = 18;
const FOOTER_HEIGHT = 10;
const ANCHOR_BOTTOM_OFFSET = 6;

export function buildClubMarkerLayout(name: string): ClubMarkerLayout {
  const safeName = String(name || "").trim();
  const longestWordWidth = Math.max(
    ...safeName
      .split(/\s+/)
      .filter(Boolean)
      .map((word) => word.length * APPROX_CHAR_WIDTH),
    MIN_WIDTH - ICON_COLUMN_WIDTH - HORIZONTAL_PADDING,
  );
  const estimatedTextWidth = Math.max(
    safeName.length * APPROX_CHAR_WIDTH * 0.68,
    longestWordWidth,
  );
  const width = Math.max(
    MIN_WIDTH,
    Math.min(MAX_WIDTH, Math.round(estimatedTextWidth + ICON_COLUMN_WIDTH + HORIZONTAL_PADDING)),
  );
  const estimatedLines = Math.max(
    1,
    Math.min(
      MAX_VISIBLE_LINES,
      Math.ceil((estimatedTextWidth || MIN_WIDTH) / Math.max(width - ICON_COLUMN_WIDTH - HORIZONTAL_PADDING, 1)),
    ),
  );
  const cardHeight = BASE_CARD_HEIGHT + Math.max(0, estimatedLines - 1) * EXTRA_LINE_HEIGHT;
  const totalHeight = cardHeight + FOOTER_HEIGHT;

  return {
    width,
    cardHeight,
    totalHeight,
    iconAnchor: [PIN_X, totalHeight - ANCHOR_BOTTOM_OFFSET],
    popupAnchor: [Math.round(width / 2) - 17, -Math.max(cardHeight - 2, 48)],
  };
}
